// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-family:PingFang SC,Microsoft YaHei,Helvetica Neue,Arial,Hiragino Sans GB,微软雅黑,SimSun,sans-serif}", ""]);
// Exports
module.exports = exports;
